import Categories from "./home-parts/Categories";
import FeaturedPosts from "./home-parts/FeaturedPosts";
import HomeLatestPosts from "./home-parts/HomeLatestPosts";
import { Helmet } from "react-helmet";
import HomePopularPosts from "./home-parts/HomePopularPosts";

function BlogHome () {
    return (
        <>
            <Helmet>
                <title>Blogs - Play Store</title>
                <meta name="description" content='Play Store Blogs are here' />
                <meta name="keywords" content='All the tutorials and blogs are here' />
                <meta property="og:title" content={"Blogs - Play Store"} />
                <meta property="og:description" content={"All the tutorials and blogs are here"} />
                <meta property="og:image" content={"appicon.png"} />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={"Blogs - Play Store"} />
                <meta name="twitter:description" content={"All the tutorials and blogs are here"} />
                <meta name="twitter:image" content={"appicon.png"} />
            </Helmet>
            
            <main className="main-content">
                {/* Hero Section */}
                <section class="hero-section">
                    <div class="hero-card">
                        <div class="hero-content">
                            <h1>Google Play Blog</h1>
                            <p>Stay updated with the latest news, tips, and stories from Google Play</p>
                            <button class="hero-btn">Subscribe to newsletter</button>
                        </div>
                    </div>
                </section>

                {/* Categories */}
                <Categories/>

                {/* Featured Posts */}
                <FeaturedPosts />

                {/* Latest Posts */}
                <HomeLatestPosts />

                {/* Popular This Month */}
                <HomePopularPosts />
            </main>
        </>
    );
}

export default BlogHome;